import { useEffect, useState } from 'react';
import api from '../lib/api';
import { useAuth } from '../lib/auth';
import { Bell } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';

export default function NotificationBell() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);

  const refresh = async () => {
    if (!user) return;
    try { const r = await api.get('/me/notifications'); setItems(r.data); } catch {}
  };
  useEffect(() => { refresh(); const i = setInterval(refresh, 30000); return () => clearInterval(i); }, [user]);

  if (!user) return null;
  const unread = items.filter(i => !i.read).length;

  const click = async (n) => {
    await api.post(`/me/notifications/${n.notif_id}/read`);
    refresh();
    if (n.link) window.location.href = n.link;
  };

  return (
    <div className="relative">
      <button onClick={() => setOpen(o => !o)} className="relative w-9 h-9 rounded-full hover:bg-muted grid place-items-center" data-testid="notification-bell">
        <Bell size={20} weight="duotone" />
        {unread > 0 && <span className="absolute top-1 right-1 w-4 h-4 bg-terracotta text-white text-[10px] rounded-full grid place-items-center">{unread}</span>}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-80 bg-card border border-border rounded-2xl shadow-2xl z-50 max-h-96 overflow-y-auto">
          <div className="p-4 border-b border-border"><p className="font-display text-lg">Notifications</p></div>
          {items.length === 0 ? (
            <p className="p-6 text-sm text-muted-foreground text-center">All caught up.</p>
          ) : items.map(n => (
            <button key={n.notif_id} onClick={() => click(n)} className={`block w-full text-left p-4 hover:bg-muted border-b border-border ${!n.read ? 'bg-muted/40' : ''}`}>
              <p className="font-medium text-sm">{n.title}</p>
              <p className="text-xs text-muted-foreground mt-0.5">{n.body}</p>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
